/*jshint ignore:start*/
(function () {


		
	function DressupGame()
	{
		//Start
		// this.debugLoad = true;

		window.ISTESTMODE = true;

		var packs = cm.app.config.main_config.challengePacks;

		this.season = 'default';

		if (this.getDebugVar('season'))
		{
			this.season = this.getDebugVar('season');
		}
		else 
		{
			// Determine the seasonal pack to be used, if any.
			packs.iterate(function(i, p) {

				// just skip doing calculation on the default "dates"
				if (p.id !== 'default')
				{	
					var now = new Date();
					var start = parseDate(p.startDate);
					var end = parseDate(p.endDate);
				
					if (end < start)
					{
						// this means we went from one year to the next (like December to January)
						end.setFullYear(now.getFullYear() + 1);
					}

					if (now >= start && now <= end && this.season === 'default')
					{
						this.season = p.id;
					}
				}

			}.bind(this));
		}

		console.log(this.season);

		function parseDate(mmdd)
		{
			var now = new Date();
			mmdd = mmdd.split('-');
			var month = parseInt(mmdd[0]) - 1; // Subtract 1 because year starts with 0 (January == 0)
			var day = parseInt(mmdd[1]);
			return new Date(now.getFullYear(), month, day);
		}



		this.initializeStages();
		this.initLayers();
		this.boot();


		this.costumePartsLibIDSlug = "CostumePartsLib";
		this.snapshotBGAssetIDSlug = "SnapshotBG";
		this.danceoffBGAssetIDSlug = "DanceoffBG";

		cm.game = this;

		// Session variables
		this.currentCharacterName = null;
		this.currentGamePhase = cm.GamePhases.CHARACTER_SELECT; // Where in the flow of the game the player is currently. Defined by cm.gamePhases
		this.chosenDanceCostume = null;
		this.savedGameplayManifest = [];

		
		this.selectedCostumes = {};
		this.selectedCostumes[cm.GamePhases.CHALLENGE_SPECIFIC_COSTUME] = {};
		this.selectedCostumes[cm.GamePhases.CHALLENGE_FREEPLAY] = {};
		this.selectedCostumes[cm.GamePhases.CHALLENGE_COLORPATTERN_COSTUME] = {};

		
	}
	var p = DressupGame.prototype;

	p.initializeStages = function()
	{
		var gameStage = this.gameStage = cm.app.display.stage;
		gameStage.snapToPixelEnabled = true;
		// gameStage.preventSelection = false; //Do this to allow an iframe to get focus

		//Setup mouse or touch
		if (cm.Device.mobile && cjs.Touch.isSupported()) 
		{
			//Enable Touchevents
			cjs.Touch.disable(this.gameStage);
			cjs.Touch.enable(this.gameStage, true);
			//Remove Mouseevents
			gameStage.enableDOMEvents(false);
		} 
		else 
		{
			//!!! This is a performance hit, especially on mobile
			//But we're only adding mouseover to Desktop
			gameStage.enableMouseOver(20);
		}

		gameStage.on('stagemousedown', function() {
			// called to let analytics know the user is interacting again
			if (cm.ViewControl.current && cm.ViewControl.current.onUserReEngage)
			{
				cm.ViewControl.current.onUserReEngage();
			}
		});


		// if(window.edit){
		// 	window.edit.init(gameStage);
		// }
	};

	p.initLayers = function() 
	{
		this.gameStage.addChild(
			new cm.Layer("Views", 0.5, 0.5),
			new cm.Layer("Debug", 0.5, 0.5),
			new cm.Layer("Transition", 0, 0),
			new cm.Layer("Loader", 0.5, 0.5)
		);

		var s = cm.app.display.stage;
		cm.Layer.alignLayers(s.width, s.height);
		cm.ViewControl.setViewLayer(cm.Layer.s.Views);

		this.blackOverlay = new cjs.Shape();
		this.blackOverlay.graphics.f('#000').dr(-1320/2, -780/2, 1320, 780);
		this.blackOverlay.set({alpha: 0, visible: false});
		cm.Layer.s.Loader.addChild(this.blackOverlay);

	};

	p.getDebugVar = function(param) 
	{
		if (window.ISTESTMODE === true)
		{
			return cm.getUrlVar(param);
		} 
		else 
		{
			return null;
		}
	};

	p.boot = function()
	{
		cm.Assets.setAssetsDictionary(cm.assetsManifests);

		cm.ViewControl.registerView("Title", cm.View.Title, false);
		cm.ViewControl.registerView("CharacterSelect", cm.View.CharacterSelect, false);
		cm.ViewControl.registerView("Challenge", cm.View.Challenge, false);
		cm.ViewControl.registerView("DanceOff", cm.View.DanceOff, false);

		this.safeArea = new cjs.Shape();
		this.safeArea.graphics.s('#f00').dr(-512, -384, 1024, 768);
		// cm.Layer.s.Debug.addChild(this.safeArea);

		if (this.debugLoad)
		{
			manifests = [
				cm.assetsManifests.Boot, 
				cm.assetsManifests.Main
			];

		}
		else 
		{
			manifests = [cm.assetsManifests.Boot];
		}

		manifests.push([{ "id": "TitleBG", "src": "assets/images/texture_title_"+ this.season +".jpg"}]);

		cm.Assets.load(manifests, this.onBootLoad.bind(this));

	};

	p.onBootLoad = function()
	{	


		this.ready = true;
		this.loadingScreen = new cm.View.Loader();
		cm.Layer.s.Loader.addChild(this.loadingScreen);

		// Using old config files from the source of the Haxe version of the game.
		cm.soundDictionary.addFromOldXML(cm.Assets.lib.oldXMLSoundConfig);
		cm.soundDictionary.addFromOldJSON(cm.app.config.sound_aliases1);

		if (!cm.Device.mobile)
		{
			this.cursor = new cjs.Sprite(cm.Assets.lib.PreloadSS, 'starcursor_default');
			this.cursor.center();
			cm.app.display.stage.addChild(this.cursor);
			// cm.app.display.stage.cursor = 'url(assets/images/starcursor_default.png)';
		}

		cm.analytics.event('load', 'Complete', null);

		cm.ViewControl.setTransitionLayer(cm.Layer.s.Transition);
		this.gotoStartView();
	};

	p.unhoverCursor = function() 
	{
		this.cursor.gotoAndStop('starcursor_default');
		// cm.removeClass(cm.app.display.stage.canvas, 'cursor_hovered');
	};

	p.hoverCursor = function() 
	{
		this.cursor.gotoAndStop('starcursor_rollover');
		// cm.addClass(cm.app.display.stage.canvas, 'cursor_hovered');
	};

	p.gotoStartView = function()
	{
		if (this.debugLoad) {
			// this.gotoChallenge('elmo');
			this.modifyAnimLibs();
			this.currentCharacterName = 'elmo';
			this.selectedCostumes[cm.GamePhases.CHALLENGE_SPECIFIC_COSTUME].top = 'pirate';
			this.selectedCostumes[cm.GamePhases.CHALLENGE_SPECIFIC_COSTUME].middle = 'pirate';
			this.selectedCostumes[cm.GamePhases.CHALLENGE_SPECIFIC_COSTUME].bottom = 'pirate';
			this.gotoDanceoff(cm.GamePhases.CHALLENGE_SPECIFIC_COSTUME);

		} else {
			// force the resize event
			cm.app.triggerResize();
			cm.ViewControl.gotoView("Title");
		}
	};

	p.gotoCharacterSelect = function() {
		cm.Assets.unload([this.savedGameplayManifest, cm.assetsManifests.AllChallenges]);
		this.savedGameplayManifest = [];

		// Reset selected costumes.
		this.selectedCostumes[cm.GamePhases.CHALLENGE_SPECIFIC_COSTUME] = {};
		this.selectedCostumes[cm.GamePhases.CHALLENGE_FREEPLAY] = {};
		this.selectedCostumes[cm.GamePhases.CHALLENGE_COLORPATTERN_COSTUME] = {};

		this.currentGamePhase = cm.GamePhases.CHARACTER_SELECT;
		cm.ViewControl.gotoLoaderThen([
			cm.assetsManifests.Main,
			cm.assetsManifests.CharacterSelect
		], this._gotoCharacterSelect.bind(this));
	};


	p._gotoCharacterSelect = function() {
		this.modifyAnimLibs();
		this.loadingScreen.animateOut().call(cm.ViewControl.gotoView, ['CharacterSelect'], cm.ViewControl);
	};

	p.decideChallengeSetFromPackConfig = function(roundCandidateID, charName) 
	{
		// Randomly get a string out of an old costume pack config file to use to select
		// a challenge set by way of the MovieClip name for the challenge set.
		// This is getting very spaghetti, I know.

		var challengePackName = this.season;
		var cfg = _.findWhere(cm.app.config.costume_packs[challengePackName].roundCandidates, {id: roundCandidateID});
		var mcNameList = [];

		mcNameList = mcNameList.concat(cfg.showcase.common);
		mcNameList = mcNameList.concat(cfg.showcase[charName]);

		if (challengePackName === 'default' || this.hasPlayedSeasonalShowcase)
		{
			mcNameList = mcNameList.concat(cfg.challenges.common);
			mcNameList = mcNameList.concat(cfg.challenges[charName]);
		}
		
		// returns an bit of a string to identify a MovieClip class name ("like-astronaut");
		return mcNameList.random();
	};	

	p.howManySameOutfitParts = function(phase) 
	{
		return this._howManySameOutfitParts(this.selectedCostumes[phase]);
	};

	p._howManySameOutfitParts = function(outfit) 
	{
		// Figure out how many parts of the chose outfit come from the same costume set.
		var last;
		var ct = 1;

		for (var o in outfit)
		{
			if (!last)
			{
				last = outfit[o];
				continue;
			}

			if (outfit[o] === last)
			{
				ct++;
				last = outfit[o];
			}
		}

		return ct;

	};


	p.getMajorityCostumeType = function(phase) 
	{
		return this._getMajorityCostumeType(this.selectedCostumes[phase]);
	};


	p._getMajorityCostumeType = function(outfit)
	{
		// Figures out if in freeplay or color/pattern
		// challenges, what the most used costume type is on the character
		// eg: if the character has pirate feet and pirate hat, but a bear body, then this function will return "pirate"
		var count = {};
		var max;
		var oname;

		for (var o in outfit)
		{
			oname = outfit[o].replace(/Color|Pattern/g, '');
			if (count[oname]) 
			{
				count[oname]++;
			}
			else 
			{
				count[oname] = 1;
			}

			if (!max || count[oname] > count[max]) 
			{
				max = oname;
			}
		}

		return max;
	};


	p.getBGNameForCostume = function(id)
	{
		var cfg = _.findWhere(cm.app.config.challenge_sets.like, {id: id});
		var bg = cfg.bg === undefined ? id : cfg.bg;
		return bg;
	};


	p.gotoChallenge = function(characterName) {
		this.currentGamePhase++;
		this.currentCharacterName = characterName;

		// this.currentGamePhase = cm.GamePhases.CHALLENGE_FREEPLAY;

		if (this.getDebugVar('phase'))
		{
			this.currentGamePhase = parseInt(this.getDebugVar('phase'));
		}

		if (this.challengePackManifest)
		{
			// Unload the set of buttons for the last challenge, if applicable.
			cm.Assets.unload([this.challengePackManifest]);
		}


		var manifests = [];
		var opts = {};

		var possibleConfigs;
		var enabledConfigs = [];
		var challengeSetType;
		var mc_name;
		var costumeManifest = [];
		var bgsManifest = []; // Costume-specific bgs
		var audioManifest = [];
		var currentGameplayManifest = [];


		// Choose the set of configs to choose from based on the phase of the game.
		switch (this.currentGamePhase) 
		{
			case cm.GamePhases.CHALLENGE_SPECIFIC_COSTUME:
				
				challengeSetType = 'like';
				possibleConfigs = cm.app.config.challenge_sets.like;
				mc_name = this.getDebugVar('costume_like') || this.decideChallengeSetFromPackConfig('outfit', characterName);
				this.challengePackManifest = cm.assetsManifests.RegChallengePack;
				break; 

			case cm.GamePhases.CHALLENGE_COLORPATTERN_COSTUME:
				
				mc_name = this.getDebugVar('costume_cp') || this.decideChallengeSetFromPackConfig('fabric', characterName);
				challengeSetType = mc_name.split('-')[0] === 'all' ? 'color' : 'pattern';
				// challengeSetType = 'color';
				possibleConfigs = cm.app.config.challenge_sets[challengeSetType];
				if (challengeSetType === 'color') 
				{
					this.challengePackManifest = cm.assetsManifests.ColorChallengePack;
				} 
				else if (challengeSetType === 'pattern') 
				{
					this.challengePackManifest = cm.assetsManifests.PatternChallengePack;
				}
				
				break;

			case cm.GamePhases.CHALLENGE_FREEPLAY:

				mc_name = this.getDebugVar('costume_free') || this.decideChallengeSetFromPackConfig('free', characterName);
				challengeSetType = 'free';	
				possibleConfigs = cm.app.config.challenge_sets.free;
				this.challengePackManifest = cm.assetsManifests.RegChallengePack;
				break;

			default:
				break;
		}

		manifests.push(this.challengePackManifest);

		opts.challengeSetType = challengeSetType;
		opts.challengeSetConfig = _.findWhere(possibleConfigs, {mc_name: 'mc_challengeSet_' + mc_name.replace('-', '')});
		

		// Choose which costume anim libs need to be loaded based on config. 
		if (opts.challengeSetConfig.load_costumes) 
		{
			opts.challengeSetConfig.load_costumes.iterate(function(i, costumeName) {
				// Only add the costume to the manifest if it hasn't already been loaded.
				if (!cm.Assets.lib[costumeName + this.costumePartsLibIDSlug])
				{
					costumeManifest.push({
						"id": costumeName + this.costumePartsLibIDSlug, "src": "assets/animations/costume-components/" + costumeName + '.js', "type":"flash_animation"
					});

					var bg = this.getBGNameForCostume(costumeName);
					bgsManifest.push({"id": bg + this.snapshotBGAssetIDSlug, "src": "assets/images/texture_snapshot_" + bg + "BG.png"});
				}
			}.bind(this));
		} 
		else if (
			!cm.Assets.lib[opts.challengeSetConfig.id + this.costumePartsLibIDSlug] 
			&& this.currentGamePhase === cm.GamePhases.CHALLENGE_SPECIFIC_COSTUME
		) 
		{
			// Only add the costume to the manifest if it hasn't already been loaded.
			costumeManifest.push({
				"id": opts.challengeSetConfig.id + this.costumePartsLibIDSlug, "src": "assets/animations/costume-components/" + opts.challengeSetConfig.id + '.js', "type":"flash_animation"
			});

			var bg = this.getBGNameForCostume(opts.challengeSetConfig.id);

			// Only add the bg to the manifest if it hasn't already been loaded.
			bgsManifest.push({"id": bg + this.snapshotBGAssetIDSlug, "src": "assets/images/texture_snapshot_" + bg + "BG.png"});
		}

		// Fetch audio manifest to load for this
		audioManifest = this.getChallengeRoundAudioManifest(characterName, challengeSetType, opts.challengeSetConfig)

		// Save this to loop through and access libs in _gotoChallenge, some things need to be modified there.
		this.loadedCostumesManifest = costumeManifest;

		// Save reference to the whole list of assets loaded for costume parts accross all challenges.
		currentGameplayManifest = costumeManifest.concat(bgsManifest);



		currentGameplayManifest = currentGameplayManifest.concat(audioManifest);
		this.savedGameplayManifest = this.savedGameplayManifest.concat(currentGameplayManifest);

		manifests.push(cm.assetsManifests.AllChallenges);
		manifests.push(currentGameplayManifest);

	

		cm.app.sound.play('curtainClose');
		cm.ViewControl.gotoLoaderThen(manifests, this._gotoChallenge.bind(this, opts));
	};

	p.getChallengeRoundAudioManifest = function(characterName, challengeSetType, challengeSetConfig) 
	{
		var manifest = [];

		if (characterName === 'elmo') 
		{
			manifest = manifest.concat(cm.assetsManifests.ElmoCommonChallengeVO);
		}
		else if (characterName === 'abby')
		{
			manifest = manifest.concat(cm.assetsManifests.AbbyCommonChallengeVO);
		}

		if (challengeSetType === 'like') 
		{

			var slug = characterName + '_like-' + challengeSetConfig.id;
			var files = cm.soundDictionary.getSoundID([
				slug + '_roundIntro',
				slug + '_complete',
				slug + '_completeResponse'
			]);

			files.iterate(function(i, f) {
				manifest.push({id: f, src: "assets/audio/vo/" + f + ".mp3"});
			});
			
		}

		return manifest;
	};

	p._gotoChallenge = function(opts) 
	{
		this._addLowerlegSegmentInfo(this.loadedCostumesManifest);
		this.loadedCostumesManifest = null;

		this.loadingScreen.animateOut().call(function() {
			cm.app.sound.play('curtainOpen');
			cm.ViewControl.gotoView('Challenge', opts);
		}, null, this);
	};

	p.gotoDanceoff = function(chosenDanceCostume) 
	{
		this.chosenDanceCostume = chosenDanceCostume;

		var costumeSet = this.selectedCostumes[chosenDanceCostume];
		var costumeName;

		var costumeManifest = [];
		var bgsManifest = [];
		
		for (var c in costumeSet) 
		{
			costumeName = costumeSet[c].replace(/Color|Pattern/g, '');
			if (!cm.Assets.lib[costumeName + this.costumePartsLibIDSlug])
			{
				costumeManifest.push({
					"id": costumeName + this.costumePartsLibIDSlug, "src": "assets/animations/costume-components/" + costumeName + '.js', "type":"flash_animation"
				});
			}
		}

		if (chosenDanceCostume === cm.GamePhases.CHALLENGE_SPECIFIC_COSTUME) 
		{
			costumeName = costumeSet.top;
			var config = _.findWhere(cm.app.config.challenge_sets.like, {id: costumeName});
			var bg = config.bg === undefined ? config.id : config.bg;


			bgsManifest.push({"id": "DanceoffBG", "src": "assets/images/texture_dance_" + bg + "BG.png"});
		}
		else 
		{
			var bg;
			if (this.howManySameOutfitParts(chosenDanceCostume) === cm.app.config.main_config.matchOutfitToBackgroundRequirement) 
			{
				bg = this.getBGNameForCostume(this.getMajorityCostumeType(chosenDanceCostume));
				bgsManifest.push({"id": "DanceoffBG", "src": "assets/images/texture_dance_" + bg + "BG.png"});
			}
			else
			{
				bgsManifest.push({"id": "DanceoffBG", "src": "assets/images/texture_dance_freeplayBG.png"});
			}
		}

		var audioManifest;

		if (this.currentCharacterName === 'abby')
		{
			audioManifest = cm.assetsManifests.AbbyDanceoffVO;
		}
		else if (this.currentCharacterName === 'elmo') 
		{
			audioManifest = cm.assetsManifests.ElmoDanceoffVO;
		}

		// Add to the saved refrence of loaded assets for gameplay.
		this.savedGameplayManifest = this.savedGameplayManifest.concat(costumeManifest);
		this.savedGameplayManifest = this.savedGameplayManifest.concat(bgsManifest);
		this.savedGameplayManifest = this.savedGameplayManifest.concat(audioManifest);

		cm.app.sound.play('curtainClose');
		cm.ViewControl.gotoLoaderThen([
			costumeManifest, 
			bgsManifest, 
			audioManifest,  
			cm.assetsManifests.DanceOff
		], this._transitionOutLoaderForDanceoff.bind(this, costumeManifest));
	};


	p._addLowerlegSegmentInfo = function(costumesManifest)
	{
		var regex = /([MB])([A-Z])$/g;

		// Loop through each costume lib, find classes of lowerleg, check what the letters
		// At the end of their names are (MB, MC, MA, BB, BC, etc). Save that info within 
		// the costume lib for later on.

		// This is the way that they named their movieclips for lower legs.. not exactly sure why
		// but from what I can see M means the lowerleg part is added when the middle costume parts are added,
		// B means it's a lowerleg part that is added when the feet are added.
		// A, B, or C after an M or B will just tell where it is layered in comparison to other lowerleg parts. 
		// So in this case like a zIndex, A will be the lowest value, C the highest (unless there are other letters I don't know about)
		// Conveniently, because of UTF-16 char codes, A < B == true and B < C == true. 

		// Not sure if this is how the original devs had their system set up but as far as I can tell this
		// makes sense and it's how I'm going to use it.
		costumesManifest.iterate(function(i, item) {
			// get costume parts lib

			var costumeLib = cm.Assets.lib[item.id];
			this.setMovieClipClassNames(costumeLib);

			costumeLib.lowerLegSegmentCodes = {};

			var res;
			var anim;

			for (var a in costumeLib) 
			{
				anim = costumeLib[a];
				if (a.indexOf('mc') === 0 && a.indexOf('lowerleg') !== -1) 
				{	

					res = regex.exec(a);
					// eg: costumeLib.lowerLegSegmentCodes.B = 'C';

					if (!costumeLib.lowerLegSegmentCodes[res[1]])
					{
						costumeLib.lowerLegSegmentCodes[res[1]] = res[2];
					}
					regex.lastIndex = 0;
				}
			}

		}.bind(this));
	};

	p.backToCharacterSelect = function() 
	{
		cm.Assets.unload([this.savedGameplayManifest, cm.assetsManifests.DanceOff]);
		this.savedGameplayManifest = [];

		// Reset selected costumes.
		this.selectedCostumes[cm.GamePhases.CHALLENGE_SPECIFIC_COSTUME] = {};
		this.selectedCostumes[cm.GamePhases.CHALLENGE_FREEPLAY] = {};
		this.selectedCostumes[cm.GamePhases.CHALLENGE_COLORPATTERN_COSTUME] = {};

		this.currentGamePhase = cm.GamePhases.CHARACTER_SELECT;
		this.savedGameplayManifest = [];
		cjs.Tween.get(this.blackOverlay)
			.set({visible: true})
			.to({alpha: 1}, 500, cjs.Ease.quadInOut)
			.call(cm.ViewControl.hardSet, ['CharacterSelect', {}], cm.ViewControl)
			.to({alpha: 0}, 300, cjs.Ease.quadInOut)
			.set({visible: false});
	};

	p.backToCostumeSnapshotSelect = function() {
		cjs.Tween.get(this.blackOverlay)
			.set({visible: true})
			.to({alpha: 1}, 500, cjs.Ease.quadInOut)
			.call(cm.ViewControl.hardSet, ['Challenge', {snapshotModeOnly: true}], cm.ViewControl)
			.to({alpha: 0}, 300, cjs.Ease.quadInOut)
			.set({visible: false});
	};

	p._transitionOutLoaderForDanceoff = function(costumeManifest) {

		if (costumeManifest.length > 0)
		{
			this._addLowerlegSegmentInfo(costumeManifest);
		}

		this.loadingScreen.animateOut().call(this._gotoDanceoff, null, this);
	};

	p._gotoDanceoff = function() 
	{
		cjs.Tween.get(this.blackOverlay)
			.set({visible: true})
			.to({alpha: 1}, 500, cjs.Ease.quadInOut)
			.call(cm.ViewControl.justHideTransition, null, cm.ViewControl)
			.call(cm.ViewControl.hardSet, ['DanceOff', {}], cm.ViewControl)
			.to({alpha: 0}, 300, cjs.Ease.quadInOut)
			.set({visible: false})
	};

	p.resize = function(w, h) 
	{
		cm.Layer.alignLayers(w, h);
		cm.ViewControl.resize(w, h);
	};

	p.update = function( deltaT )
	{
		if(!this.ready) 
		{
			return;
		}


		if (this.cursor)
		{
			var s = cm.app.display.stage;
			this.cursor.set({x: s.mouseX, y: s.mouseY});
		}


		if (this.loadingScreen) 
		{
			this.loadingScreen.update();
		}

		cm.ViewControl.update(deltaT);

	};


	p.modifyAnimLibs = function() 
	{
		// Make some movieclip lib additions.
		this.setMovieClipClassNames(cm.Assets.lib.MainAnimsLib);
		this.setMovieClipClassNames(cm.Assets.lib.LipsyncSymbolsLib);

		var anim;
		var lib = cm.Assets.lib.MainAnimsLib;


		for (var a in lib) 
		{
			anim = lib[a];
			if (a.indexOf('mc_abby_headpart_mouthSync') === 0 || a.indexOf('mc_elmo_headpart_mouthSync') === 0)
			{

				// Add function to prototype of the two lipsync container symbols to play lipsync.
				anim.prototype.playLipsync = function(voAlias, onEndCallback)
				{
					var _voAlias = voAlias;
					
					voAlias = voAlias.replace('-', ''); // Since animate exports symbols with hyphens in their names by taking out the hyphens >:| 
					
					var charName = this.className.split('_')[1];
					var lipsyncInstance;
					var lipsyncClass;
					var lipsyncClassName;

					lipsyncClassName = 'mc_' + charName + '_lipsynch_' + voAlias;
					lipsyncClass = cm.Assets.lib.LipsyncSymbolsLib[lipsyncClassName];

					if (!lipsyncClass) {
						console.log('WARNING: NO LIPSYNC CLASS FOR: ' + lipsyncClassName);
					}
					
					if (typeof lipsyncClass === 'function')
					{
						console.log('PLAYING LIPSYNC: ' + lipsyncClassName);
						lipsyncInstance = new lipsyncClass();
						
						if (this.lipsyncInstance) {
							this.lipsyncInstance.stop();
							this.removeChild(this.lipsyncInstance);
						}

						this.lipsyncInstance = lipsyncInstance;


						lipsyncInstance._endCallback = function() 
						{
							console.log("END CALLBACK");
							this.stop();

							this.parent.default_mouth.visible = true;
							this.parent.lipsyncInstance = null;
							this.parent.removeChild(this);
							this.parent = null;

							if (this.onAnimationEndCallback)
							{
								var cb = this.onAnimationEndCallback;
								this.onAnimationEndCallback = null;
								cb();							
							}
							
						};

						this.default_mouth.visible = false;

						this.addChild(lipsyncInstance);
						lipsyncInstance.onAnimationEndCallback = onEndCallback;
						lipsyncInstance.parent = this;
						lipsyncInstance.timeline._tweens[0].call(lipsyncInstance._endCallback).wait(1); // Add action to the actions timeline
							

						// More tween gymnastics. 
						//Prepend each tween with a couple frames, so that the audio isn't called right on the first frame.
						var o;
						var step;
						var tween;
						var beginningPad = 2;
						for (var i = 0, l = lipsyncInstance.timeline._tweens.length; i < l; i++)
						{
							tween = lipsyncInstance.timeline._tweens[i];


							o = tween._cloneProps(tween._curQueueProps);
							step = {d: beginningPad, p0:o, e:undefined, p1:o, v: undefined};
							if (step.d > 0) 
							{
								step.t = 0;
								tween._steps.unshift(step);
								tween.duration += step.d;
							}

							for (var j = 1, jl = tween._steps.length; j < jl; j++)
							{
								tween._steps[j].t += beginningPad;
							}

							for (var j = 0, jl = tween._actions.length; j < jl; j++)
							{
								tween._actions[j].t += beginningPad;
							}
						}




						lipsyncInstance.timeline.updateDuration();
						lipsyncInstance.gotoAndPlay(0);
					}
					else if (cm.app.sound.exists(cm.soundDictionary.getSoundID(_voAlias)))
					{
						console.log("WARNING: THERE WAS A PROBLEM WITH LIPSYNC, FALLING BACK TO AUDIO ONLY");
						cm.app.voPlayer.play(cm.soundDictionary.getSoundID(_voAlias), onEndCallback);
					}
					else if (onEndCallback)
					{
						onEndCallback();
					}
				}

				anim.prototype.stopLipsync = function() 
				{
					if (this.lipsyncInstance) {
						this.lipsyncInstance.stop();
						this.removeChild(this.lipsyncInstance);
						this.lipsyncInstance = null;
					}
					this.default_mouth.visible = true;
				};
			}
			else if (a.indexOf('mc_paperdoll_') === 0)
			{

				// Get body part from a character's movieclip
				anim.prototype.getBodypartInstances = function(partClassName)
				{

					if (!this._instanceMap) 
					{
						var className;
						var i = 1;
						var instance = this.instance;
						
						this._instanceMap = {};

						while (instance)
						{
							className = instance.className;
							if (!this._instanceMap[className]) 
							{
								this._instanceMap[className] = [];
							}
							this._instanceMap[className].push(instance);

							instance = this['instance_'+i];
							i++;
						}
					}

					// console.log('GETTING BODY PART INSTANCE OF: ' + partClassName);

					return this._instanceMap[partClassName];

				}
			}
		}
	};


	p.setMovieClipClassNames = function(lib) 
	{
		var anim;
		for (var a in lib) 
		{
			anim = lib[a];
			if (anim.prototype instanceof cjs.MovieClip) 
			{
				anim.prototype.className = a;
			}
		}
	};



	p.addCostumeParts = function (args) 
	{
		var instance;
		var name;
		
		var costumeLib = args.costumeLib;
		var characterMovieClip = args.characterMovieClip;
		var charName = args.charName;
		var partName = args.partName;
		var costumeName = args.costumeName;
		var part;
		var partClassName;

		instanceList = characterMovieClip.getBodypartInstances('mc_' + charName + '_container_' + partName);

		// get the object type from the lib that will be used to make a new costume part
		// and then put on the character.
		var partClass;

		if (partName === 'lowerleg') 
		{
			partClassName = 'mc_' + charName + '_' + partName + '_outfit_' + costumeName + args.lowerLegSegment + costumeLib.lowerLegSegmentCodes[args.lowerLegSegment]
		}
		else 
		{
			partClassName = 'mc_' + charName + '_' + partName + '_outfit_' + costumeName;
		}

		partClass = costumeLib[partClassName];
		console.log('ADDING COSTUME PART: ' + partClassName);

		for (var i = 0, l = instanceList.length; i < l; i++) 
		{
			instance = instanceList[i];

			if (partName === 'cape') 
			{
				// Hide cape container no matter what, as abby probably doesn't need to show her wings when in costume. 
				instance.instance.visible = false;
			}

			if (partClass) 
			{
				part = new partClass();
				if (partName === 'head') 
				{
					// hide the default.
					instance.outfitContainer.instance.visible = false;
					instance.outfitContainer.addChild(part);
				} 
				else 
				{
					if (partName === 'lowerleg')
					{
						instance.instance.z = 0;
						
						var code = costumeLib.lowerLegSegmentCodes[args.lowerLegSegment];
							
						// Lower leg segment code is A, B, or C,  A being the lowest value. 
						// This has to be handled like this because of the way the names of the movieclips were set up.
						part.z = code.charCodeAt(0);
						part.segmentCode = code;
						part.costumeName = costumeName;
						instance.addChild(part);

						instance['lowerlegPart'+args.lowerLegSegment] = part;


						console.log(args.lowerLegSegment, code);

						// So.. in freeplay, if a costume has a bottom (B) type lowerleg part, and a middle (M) lowerleg part
						// that both have the same segment code (like one is MC and the other is BC)
						// the B part needs to be hidden otherwise sometimes things will layer oddly.
						if (
							(args.lowerLegSegment === 'M' && instance.lowerlegPartB && instance.lowerlegPartB.segmentCode === code)
							|| (args.lowerLegSegment === 'B' && instance.lowerlegPartM && instance.lowerlegPartM.segmentCode === code)
						)
						{
							var cosName = instance.lowerlegPartM.costumeName;


							if (!(!!instance.lowerlegPartM && (cosName.indexOf('baseball') !== -1 || cosName.indexOf('pirate') !== -1)))
							{
								// ugh.. edge case because baseball has lowerlegMC-type parts, but they don't 
								// actually cover the whole leg. >:E
								instance.instance.visible = false;
								instance.lowerlegPartB.visible = false;
							}
						}
						instance.sortChildren(cm.sortByZ);	
					
					} 
					else 
					{
						instance.instance.visible = false;
						instance.addChild(part);
					}


				}	
			}
		}
	};


	p.iterateMCInstances = function(movieClip, iter) {
		var instance = movieClip.instance;
		var i = 0;

		while (instance) 
		{
			iter(instance);
			instance = movieClip['instance_' + (++i)];
		}
	};



	cm.DressupGame = DressupGame;


	cm.sortByZ = function(obj1, obj2) {
		if(obj1.z === undefined || obj2.z === undefined) {
			// console.log(obj1, obj2);
		}
		if (obj1.z > obj2.z) {return 1;}
		if (obj1.z < obj2.z) {return -1;}
		return 0;
	};



})();

/*jshint ignore:end*/
